import React from 'react'
import Navbar from '../components/navbar/navbar'
import Footer from '../components/footer'

const HowItWork = () => {

    const realEstateData = [
        { type: "Multifamily", description: "Buildings with multiple residential units (more than 4 units)." },
        { type: "Office Space", description: "Workspaces for businesses and professionals." },
        { type: "Single Tenant Office", description: "Office leased to one business." },
        { type: "Restaurant Space", description: "Designed for food service businesses." },
        { type: "Special Purpose", description: "Built for unique, specific uses ex. house of worship, stadium." },
        { type: "Warehouse Space", description: "Storage and distribution facilities." },
        { type: "Residential", description: "Housing for individuals and families (up to 4 units)." },
        { type: "Industrial Space", description: "Facilities for manufacturing and logistics." },
        { type: "Flex Space", description: "Hybrid of office and industrial use." },
        { type: "Retail Space", description: "Stores selling goods and services." },
        { type: "Single Tenant Retail", description: "Retail space leased to one tenant." },
    ];

    return (
        <>
            <Navbar transparent={false} />
            <section>
                <div className="container">
                    <h2><span className="font-normal" style={{ color: "#00a94f" }}>
                        How It Works!</span></h2>
                    <p className='content-i'>
                        Imagine a world where finding the perfect commercial space—anywhere on
                        the planet—is as easy as a click. That’s why we built this platform,
                        engineered for the global real estate community with one mission: to
                        seamlessly connect vacant commercial spaces and properties for sale with
                        business owners worldwide.

                        <ul id="howitworks-list">
                            <li>
                                Need an office in Atlanta while based in Dubai? Done.
                            </li>
                            <li>
                                Expanding your restaurant chain to Lagos? We’ve got you.
                            </li>
                            <li>
                                Setting up a headquarters in Singapore? Consider it handled.
                            </li>
                            <li>
                                Searching for an R&D facility in Auckland? Look no further.
                            </li>
                        </ul>
                    </p>
                    <p className='content-i'>
                        This platform is more than a tool—it’s your strategic partner, your trusted
                        ally, making global expansion effortless. Let’s build the future of business,
                        together.
                    </p>
                    <div className='w-100 justify-content-center d-flex align-items-center'>
                        <img src={require('../assets/img/Map.png')} height={"auto"} width={"85%"} />
                    </div>

                    <h2><span className="font-normal" style={{ color: "#00a94f" }}>
                        The Mobile App</span></h2>
                    <p className='content-i'>
                        Get the Mobile App! Our app, seamlessly integrated with the website, is
                        available for free on the Apple App Store and Google Play Store. Download
                        it now for easy access on the go!
                    </p>

                    <div className='w-100 justify-content-center d-flex align-items-center mt-5 mb-5'>
                        <img src={require('../assets/img/Mobile App Art.jpg')} height={"auto"} width={"85%"} />
                    </div>

                    <h2><span className="font-normal" style={{ color: "#00a94f" }}>
                        Property Types</span></h2>
                    <p className='content-i'>
                        Explore the right property for your needs. Below, you'll find a selection of
                        available property types, each with a brief overview to help you make the
                        best choice.
                    </p>

                    <h2 className='mt-5'><span className="font-normal" style={{ color: "#00a94f" }}>
                        Property Category</span></h2>

                    <table className="min-w-full text-left mt-4">
                        <thead>
                        </thead>
                        <tbody>
                            {realEstateData.map((item, index) => (
                                <tr key={index} className="">
                                    <td className="px-4 py-2" style={{ fontWeight: "bolder" }}>{item.type}</td>
                                    <td className="px-4 py-2 text-black">{item.description}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default HowItWork